<div [formGroup]="form" (keydown.enter)="onSubmit ()">
  <ngb-alert [ngStyle]="{ 'visibility': getError() ? 'visible' : 'hidden' }"  [type]="'danger'" (click)="hideError()">{{ getError() }}</ngb-alert>
  <div class="mb-3 mb-2">
    <label for="answer" >{{ prompt }}</label>
    <div class="input-group input-group mb-3">
      <input [type]="inputType()" #pw formControlName="password" id="answer" class="form-control " />
        <button (click)="toggleInputType()" class='btn btn-link border'>
          <fa-icon icon="eye" ></fa-icon>
      </button>
    </div>
  </div>
  <footer-submit-cancel #foot (submit)="onSubmit ()"  (cancel)="onCancel ()"></footer-submit-cancel>
</div>